import { registerSW } from 'virtual:pwa-register';
import { createUpdatePrompt } from '@bn-games/ui-shell';
import { t } from './i18n/I18n';

let registered = false;

/**
 * Boot the service worker. Safe to call once per page load. When the SW
 * detects a new build, the user is prompted before the page reloads — we do
 * not silently swap mid-game, since that would lose in-progress state.
 */
export function registerServiceWorker(): void {
  if (registered) return;
  registered = true;

  const updateSW = registerSW({
    onNeedRefresh() {
      createUpdatePrompt({
        title: t('pwa.updateAvailable.title'),
        body: t('pwa.updateAvailable.body'),
        refreshLabel: t('pwa.updateAvailable.refresh'),
        dismissLabel: t('pwa.updateAvailable.later'),
        onConfirm: () => updateSW(true),
      });
    },
  });
}
